import './styles.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme, SoundsProvider, createSounds } from 'arwes';
import { Routes } from './Routes';

const sounds = {
  shared: {
    volume: 0.6,
  },
  players: {
    click: {
      sound: { src: ['/assets/sounds/click.mp3'] },
      settings: { oneAtATime: true },
    },
    typing: {
      sound: { src: ['/assets/sound/typing.mp3'] },
      settings: { oneAtATime: true },
    },
    deploy: {
      sound: { src: ['/assets/sound/deploy.mp3'] },
      settings: { oneAtATime: true },
    },
  },
};

function App({ Router = BrowserRouter }) {
  return (
    <ThemeProvider theme={createTheme()}>
      <SoundsProvider sounds={createSounds(sounds)}>
        <Router>
          <div className="App">
            <Routes />
          </div>
        </Router>
      </SoundsProvider>
    </ThemeProvider>
  );
}

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);
